export enum EditStateEnum {
    edited,
    deleted
  }